import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
/** 
 * @description integrates the vue router routes and 
 * defines the router guard
 * @exports VueRouter
 */

Vue.use(VueRouter)

const router = new VueRouter({
  routes
})

/**
 * This will have a more concise implentation down the road, once we
 * start using vuex.
 * https://router.vuejs.org/guide/advanced/navigation-guards.html
 */
router.beforeEach((to, from, next) => {
  // authentication route guard
  if(to.matched.some(route => route.meta.requiresAuth)) {
    // determine if logged in
    const isAuth = isLoggedIn()
    console.log("to.fullpath ", to.fullPath)
    if(isAuth) {
      if(to.matched.some(route => route.meta.requiresIntegrator)) {
        // if user is not an integrator and customerId === userProfile.CompanyId,
        // then user must change scope (i.e. customerId) to an integrator
        const user = getUser()
        if ((to.params.customerId === "undefined") ||
            (!user.role.name.includes("integrator") && user.companyId === to.params.customerId)) {
          alert("You must set your scope to an Integrator before navigation to " + to.path);
        } else {  // scope is already at an Integrator, proceed
          console.log("scope to route is already integrator")
          next()
        }
      } else {  // Route does not require integrator, proceed
        console.log("integrator not required")
        next()
      }
    } else {  // Auth required but not met, push to login
      console.log("auth required, not met, push to login ", window.location.pathname, to.path, to.fullPath)
      sessionStorage.setItem('redirectPath', to.path)
      next({
        path: `/login/${Math.random().toString(20).substr(2, 6)}` // unique value triggers a change to show login required alert
      })
    }
  } else {  // auth not required; proceed
    console.log("auth not required")
    next()
  } 
})

const isLoggedIn = () => {
  const storage = localStorage.getItem("userProfile")
  if(storage) {
    const user = JSON.parse(storage)
    if(Object.keys(user).length > 0) {
      // a user is signed in.
      return true
    } else {
      // no user signed in
      return false
    }
  } else return false
}

const getUser = () => {
  const storage = localStorage.getItem("userProfile")
  if(storage) {
    return JSON.parse(storage)
  } else {
    return {}
  }
}

export default router